import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminSignIn() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const ADMIN_PASSWORD = 'whipt2026admin';

  useEffect(() => {
    // If already authed (session or dev mode), skip
    if (sessionStorage.getItem('whipt_admin_auth') === 'true' || localStorage.getItem('whipt_dev_mode') === 'true') {
      navigate('/admin', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    setTimeout(() => {
      if (password === ADMIN_PASSWORD || localStorage.getItem('whipt_dev_mode') === 'true') {
        sessionStorage.setItem('whipt_admin_auth', 'true');
        navigate('/admin', { replace: true });
      } else {
        setError('Invalid admin password');
      }
      setLoading(false);
    }, 200);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#05020b] via-[#0a0513] to-[#0f0820] px-4">
      <form onSubmit={handleSubmit} className="w-full max-w-md bg-[#0f0a1c] border border-[#24153c] rounded-xl p-6 shadow-xl text-white space-y-4">
        <div>
          <h1 className="text-2xl font-semibold">Admin Sign-In</h1>
          <p className="text-sm text-slate-400 mt-1">Enter the admin password to continue.</p>
        </div>
        <div className="space-y-2">
          <label className="text-sm text-slate-300">Admin Password</label>
          <div className="flex items-center gap-2 bg-[#110d1f] border border-[#24153c] rounded-lg px-3 py-2">
            <input
              type={showPassword ? 'text' : 'password'}
              className="flex-1 bg-transparent outline-none text-white placeholder:text-slate-500"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={() => setShowPassword((s) => !s)}
              className="text-xs text-slate-400 hover:text-white"
            >
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>
          {error && <p className="text-sm text-red-400">{error}</p>}
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-amber-500 hover:bg-amber-600 text-black font-semibold py-2 rounded-lg disabled:opacity-70"
        >
          {loading ? 'Checking…' : 'Unlock Admin'}
        </button>
        <p className="text-xs text-slate-500 text-center">This gate is local-only. It sets sessionStorage and stays on this device.</p>
      </form>
    </div>
  );
}
